export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11152.4ee7209a.jpg";